// UNPROTECTED
export const ROUTE_LOGIN = '/login'
export const ROUTE_REGISTER = '/register'
export const ROUTE_FORGOT_PASSWORD = '/forgot-password'
export const ROUTE_HOME = '/'
//to do replace this with real routes
export const ROUTE_DESTINATIONS = '/destinations'

// SETTINGS
export const ROUTE_MY_BETS = '/my-bets'
export const ROUTE_MY_DETAILS = '/my-details'
export const ROUTE_SETTINGS = '/settings'
